import React, { useEffect } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Portal from './portal'

function Modal({
  className,
  onClose,
  maskClosable,
  closable,
  visible,
  children,
})
{
  const onMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(e)
    }
  }

  const close = (e) => {
    if (onClose) {
      onClose(e)
    }
  }

useEffect(() => {
  document.body.style.cssText = `position: fixed; top: -${window.scrollY}px`
  return () => {
    const scrollY = document.body.style.top
    document.body.style.cssText = `position: ""; top: "";`
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }
}, [])

  return (
    <>
      <Portal elementId="modal">
        <ModalOverlay visible={visible} />
        <ModalWrapper
          className={className}
          onClick={maskClosable ? onMaskClick : null}
          tabIndex={-1}
          visible={visible}
        >
          <ModalInner tabIndex={0} className="modal-inner">
              {closable && <div style={{display: 'flex', justifyContent: 'right', marginBottom: 15}}><button className="modal-close" onClick={close}>X</button></div>}
              {children}
          </ModalInner>
        </ModalWrapper>
      </Portal>
    </>
  );
}

Modal.defaultProps = {
  visible: false,
  closable: true,
  maskClosable: true,
}

Modal.propTypes = {
  visible: PropTypes.bool,
}

const ModalWrapper = styled.div`
  box-sizing: border-box;
  display: ${(props) => (props.visible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
`

const ModalOverlay = styled.div`
  box-sizing: border-box;
  display: ${(props) => (props.visible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
`

const ModalInner = styled.div`
  box-sizing: border-box;
  position: absolute;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  background-color: #fff;
  border-radius: 10px;
  min-width: 80%;
  width: 90%;
  max-width: 700px;
  top: 70%;
  left: 10%;
  transform: translateY(-50%);
  margin: 0 auto;
  padding: 40px 20px;
`

export default Modal;